import request from '../../utils/request';

export const getObjectNumListService = array => {
  if (array === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/items/objectNumbers', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/items/objectNumbers', {
        method: 'GET',
        params: { id: array },
      }),
    );
    return response;
  };
};
